<template>
  <div class="draw_wrap" >
    <div class="draw_title" ></div>
    <div class="draw_content" >
      <div class="circle_wrap" >
        <div class="score_wrap" >当前积分：{{ userVo.userIntegral }} </div>
        <div class="flower" >
          <div class="pie" >
            <div class="pointer" @click="startRotation" ></div>
            <round-turntable
              ref="roundTurntable"
              :prizeData="luckDrawGoodsVoList"
              :rotateCircle="rotateCircle"
              :duringTime="duringTime"
              :turntableStyleOption="turntableStyleOption"
              @endRotation="endRotation"
              class="turntable">
              <template slot="item" slot-scope="scope">
                <div class="turntable-name"  >{{ scope.item.luckDrawGoodsName }} </div>
                <div class="turntable-img" v-if="scope.item.picUrl" :class="{ 'long_name': scope.item.luckDrawGoodsName.length > 4 }" >
                  <img :src="scope.item.picUrl">
                </div>
              </template>
            </round-turntable>
          </div>
        </div>
      </div>
    </div>
    <div class="swipe_wrap" v-if="luckDrawGoodsOrderVoList.length > 0" >
      <van-swipe vertical class="swipe_list" loop :show-indicators="false" :autoplay="3000" :touchable="false" >
        <van-swipe-item v-for="(item, index) in luckDrawGoodsOrderVoList" :key="index" >
          <div class="swipe_block" >
            <img :src="item.headImgUrl" class="head_img" />
            <div>{{ item.nickName }} 抽中{{ item.luckDrawGoodsName }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="active_rule" >
      <div class="rule_title" >
        <div class="dot" ></div>
        <div>活动规则</div>
        <div class="dot" ></div>
      </div>
      <div class="rule_content" v-html="luckDrawVo.remark" >
<!--        <div class="rule" >活动规则</div>
        <div class="rule_item" >1、购买1元得1积分，购买“直升品”得双倍积分。</div>
        <div class="rule_item" >2、100积分即可抽奖1次，每位客户最多可抽奖3次；</div>
        <div class="rule_item" >3、进入指定抽奖区进行抽奖，中奖后进入领奖</div>
        <div class="rule_item" >4、活动期间自购消费商品可获得等额积分(如消费100元就会获得100积分)</div>
        <div class="rule_item" >5、订单退款奖品无效</div>-->
      </div>
    </div>
    <div class="footer" >活动最终解释权归北边健康所有</div>

    <van-popup v-model="show" >
      <div class="draw_success_wrap" >
        <div class="success_title" ></div>
        <div class="success_content" >
          <div class="awards_title" >恭喜您抽中了{{ luckDrawGoodsVo.luckDrawGoodsName }}</div>
          <img :src="luckDrawGoodsVo.picUrl" class="success_img" />
          <div class="success_text" v-if="luckDrawGoodsVo.storeCouponId" >已发放，在【我的优惠券】查看如有疑问请联系客服。</div>
          <div v-else class="success_text" >请在“设置-中奖记录”中领取</div>
          <img src="./img/get.png" class="success_btn" @click="winningRecord" />
        </div>
      </div>
      <div class="close" @click="show = false" ></div>
    </van-popup>

    <van-popup v-model="fail" >
      <div class="draw_success_wrap" >
        <div class="success_title" ></div>
        <div class="success_content" >
          <div class="fail_text" >“再接再厉”</div>
          <div class="success_text" >很遗憾，未中奖</div>
          <img src="./img/continue.png" class="success_btn" @click="fail = false" />
        </div>
        <div class="close" @click="fail = false" ></div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<style>
.turntable {
  position: absolute;
  left: calc(50% - 200px);
  top: calc(50% - 200px);
  width: 400px;
  height: 400px;
}
.turntable-name {
  /*background: pink;*/
  /*position: absolute;*/
  /*left: 10px;*/
  /*top: 10px;*/
  font-size: 12px;
  /*width: 50px;*/
  /*margin-left: 20px;*/
  text-align: center;
  width: 50px;
  margin: 10px auto 0;
  color: #C70629;
  line-height: 15px;
}

.long_name {
  top: 40px !important;
}

.turntable-img {
  position: absolute;
  /*要居中就要50% - 宽度 / 2*/
  left: calc(50% - 35px / 2);
  top: 30px;
  width: 35px;
  height: 20px;
}

.turntable-img > img {
  width: 100%;
  height: 100%;
  border-radius: 2px;
  object-fit: cover;
}
</style>
<script>
// 抽奖组件
import roundTurntable from '@/components/roundTurntable';
import {getUserInfo} from "../../api/login";
import { luckDraw, getLuckDrawGoodsOrderVoList } from "../../api/luckdraw";
import { Toast } from 'vant'
export default {
  name: 'luckDraw',
  data() {
    return {
      // 转动的圈数
      rotateCircle: 10,
      // 转动需要持续的时间（s）
      duringTime: 4.5,
      // 转盘样式的选项
      turntableStyleOption: {
        // 背景色
        prizeBgColors: ['#fff', 'rgb(255, 226, 188)', '#fff', 'rgb(255, 226, 188)', '#fff', 'rgb(255, 226, 188)', '#fff', 'rgb(255, 226, 188)', '#fff', 'rgb(255, 226, 188)'],
        // 转盘的外边框颜色
        // borderColor: '#199301',
      },

      // 中奖的奖品的index
      prizeIndex: -1,
      // 用来锁定转盘，避免同时多次点击转动
      isLocking: false,
      show: false,
      fail: false,
      userVo: {
        userIntegral: 0
      },
      luckDrawGoodsVoList: JSON.parse(localStorage.getItem('luckDrawGoodsVoList')),
      luckDrawVo: JSON.parse(localStorage.getItem('luckDrawVo')),
      code: -1,
      luckDrawGoodsVo: {},
      luckDrawGoodsOrderVoList: []
    }
  },
  components: {
    roundTurntable
  },
  methods: {
    winningRecord() {
      // const { luckDrawGoodsVo } = this
      this.$router.push({ name: 'winningRecord' })
     /* console.log({...luckDrawGoodsVo})
      if(luckDrawGoodsVo.storeCouponId) {
        this.show = false
      }else {
        this.$router.push({ name: 'winningRecord' })
      }*/
    },
    luckDraw(callback) {
      const { luckDrawId } = this.$route.params
      luckDraw({ luckDrawId }).then(res => {
        if(res.success) {
          callback(res)
        }else {
          callback(res)
        }
      })
    },
    // 判断是否可以转动
    canBeRotated() {
      if (this.isLocking) {
        return false;
      }
      return true;
    },
    startRotation() {
      // 如果还不可以转动
      if (!this.canBeRotated()) {
        return false;
      }
      this.isLocking = true;
      this.luckDraw(res => {
        console.log('code:', res)
        let code = res.code
        if(code === '0' || code === '11202') {
          this.getUserInfo()
          let index = -1
          this.code = code
          if(code === '11202') {
            index = this.luckDrawGoodsVoList.findIndex(item => { return item.luckDrawGoodsName === '再接再厉' })
          }
          if(code === '0') {
            this.luckDrawGoodsVo = res.data.luckDrawGoodsVo
            index = this.luckDrawGoodsVoList.findIndex(item => {return item.luckDrawGoodsId === res.data.luckDrawGoodsVo.luckDrawGoodsId})
          }
          // 设置在哪里停下，应该与后台交互，这里随机抽取0~5
          // const index = Math.floor(Math.random() * this.luckDrawGoodsVoList.length);
          // 成功后次数减少一次
          this.prizeIndex = index;
          // 告诉子组件，开始转动了
          this.$refs.roundTurntable.rotate(index);
        }else {
          Toast(res.msg)
        }
      })
    },
    endRotation() {
      const { code } = this
      // 提示中奖
      // alert(`恭喜您获奖啦,您的奖品是：${this.prizeData[this.prizeIndex].prizeName}`);
      if(code === '0') {
        this.show = true
      }else {
        this.fail = true
      }
      // 解锁
      this.isLocking = false;
    },
    getUserInfo() {
      getUserInfo({}).then(res => {
        if(res.success) {
          localStorage.setItem('userVo', JSON.stringify(res.data.userVo))
          this.userVo = res.data.userVo
        }
      })
    },
    getLuckDrawGoodsOrderVoList() {
      const { luckDrawId } = this
      getLuckDrawGoodsOrderVoList({ luckDrawId, pageSize: 10 }).then(res => {
        if(res.success) {
          this.luckDrawGoodsOrderVoList = res.data
        }
      })
    }
  },
  mounted() {
    this.getUserInfo()
    this.getLuckDrawGoodsOrderVoList()
  }
}
</script>
